var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isUserAuthenticated
    ? _c(
        "div",
        { staticClass: "navigation-container" },
        [
          _c("AppBarComponent", { attrs: { "window-width": _vm.windowWidth } }),
          _vm.configurationDrawerStatus
            ? _c("ConfigurationDrawerComponent", {
                attrs: {
                  "window-width": _vm.windowWidth,
                  isFooterVisible: _vm.isFooterVisible,
                },
              })
            : _c("DrawerComponent", {
                attrs: {
                  mini: _vm.drawerInMiniStatus,
                  "window-width": _vm.windowWidth,
                  collapseButtonIsClicked: _vm.collapseButtonIsClicked,
                  isFooterVisible: _vm.isFooterVisible,
                  drawerHeight: _vm.drawerHeight,
                },
                on: { "toogle-navigation-drawer": _vm.changeDrawerStatus },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }